import { useState, useEffect } from 'react';

// Manages filters state 
export const useRecordFilters = () => {
    const [search, setSearch] = useState('');
    const [worker, setWorker] = useState('');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');

    const setFilters = ({ search = '', worker = '', dateFrom = '', dateTo = ''}) => {
        setSearch(search);
        setWorker(worker);
        setDateFrom(dateFrom);
        setDateTo(dateTo);
    };

    const resetFilters = () => setFilters({});

    return { search, worker, dateFrom, dateTo, setFilters, resetFilters};
};
